var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { diff } from "just-diff";

import Form from "@rjsf/material-ui";

import { exportFormDataValeus, formDataValues, formDefaultValues, formToJSONSchema, formToUISchema } from "./formTransformer";
import { compare } from "./utils/objectUtils";

import CustomObjectFieldTemplate from "./widgets/CustomObjectFieldTemplate";
import CustomObjectField from "./widgets/CustomObjectField";
import CustomArrayField from "./widgets/CustomArrayField";
import CustomFieldTemplate from "./widgets/CustomFieldTemplate";
import TitleWidget from "./widgets/mui/TitleWidget";
import TextFieldWidget from "./widgets/mui/TextFieldWidget";
import TextareaWidget from "./widgets/mui/TextareaWidget";
import RadioGroupWidget from "./widgets/mui/RadioGroupWidget";
import CheckboxesGroupWidget from "./widgets/mui/CheckboxesGroupWidget";
import MultipleUploadWidget from "./widgets/mui/MultipleUploadWidget";
import SelectWidget from "./widgets/mui/SelectWidget";
import TableEditableWidget from "./widgets/mui/TableEditableWidget";
import ReactDatePicker from "./widgets/mui/ReactDatePicker";
import RichTextField from "./widgets/RichTextField";
import LinkWidget from "./widgets/mui/LinkWidget";
import LocationWidget from "./widgets/mui/LocationWidget";
import ParagraphWidget from "./widgets/mui/ParagraphWidget";
import CpfWidget from "./widgets/mui/CpfWidget";
import MaskWidget from "./widgets/mui/MaskWidget";
import CnpjWidget from "./widgets/mui/CnpjWidget";
import { defaultValidation, transformErrors } from "./validation";
import "whatwg-fetch";
import "moment/locale/pt-br";

import "bootstrap-grid/dist/grid.css";

import "./index.css";

var FormDinamicoReactRender = function (_PureComponent) {
  _inherits(FormDinamicoReactRender, _PureComponent);

  function FormDinamicoReactRender() {
    var _temp, _this, _ret;

    _classCallCheck(this, FormDinamicoReactRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      localFormData: _extends({}, formDefaultValues(_this.props.form), formDataValues(_this.props.formData))
    }, _this.parseFetchedValues = function (integration, json, modifiedFieldFormData) {
      var formData = {};

      integration.returns.forEach(function (item) {
        Boolean(item.value) && (formData[item.value] = json[item.name]);
      });

      var localFormData = _this.state.localFormData || {};

      _this.setState({
        localFormData: _extends({}, localFormData, modifiedFieldFormData, formData)
      });
    }, _this.fetchFormForFieldChange = function (integration, changes, formData) {
      var headers = _this.props.environment.headers;


      var params = _this.findIntegrationParams(integration, changes, formData);
      var queryString = _this.toQueryString(params);
      var serviceURL = integration.operation + "/" + integration.service + queryString;

      fetch(serviceURL, { method: "GET", headers: headers || {} }).then(function (res) {
        return res.json();
      }).then(function (json) {
        Object.keys(json).length && _this.parseFetchedValues(integration, json, formData);
      }).catch(function (e) {
        return console.error(e);
      });
    }, _this.findIntegrationParams = function (integration, changes, formData) {
      var _ref;

      var params = [];

      integration.parameters.forEach(function (mappedParam) {
        var value = formData[mappedParam.name];
        var name = mappedParam.value;
        if (value && name) {
          var param = {};
          param[name] = value;
          params.push(param);
        }
      });

      if (params.length) {
        return params;
      }

      return [(_ref = {}, _ref[changes.path[0]] = changes.value, _ref)];
    }, _this.toQueryString = function (params) {
      var qs = "?";

      params.forEach(function (param) {
        Object.keys(param).forEach(function (key, index) {
          if (index > 0) qs += "&";
          qs += key + "=" + param[key];
        });
      });

      return qs;
    }, _this.findIntegrationInChanges = function (integration, changes) {
      return changes.find(function (item) {
        return item.path[0] === integration;
      });
    }, _this.modifyFormForChanges = function (changes, formData) {
      var form = _this.props.form;
      var _form$integrations = form.integrations,
          integrations = _form$integrations === undefined ? [] : _form$integrations;


      integrations.forEach(function (item) {
        var modifiedField = _this.findIntegrationInChanges(item.element, changes);

        Boolean(modifiedField) && _this.fetchFormForFieldChange(item, modifiedField, formData);
      });
    }, _this.handleChange = function (event) {
      var formData = event.formData;
      var onChange = _this.props.onChange;


      var capturedChanges = diff(_this.state.localFormData, formData).filter(function (item) {
        return ["add", "replace"].includes(item.op) && Boolean(item.value);
      });

      capturedChanges.length && _this.modifyFormForChanges(capturedChanges, formData);

      onChange && onChange(exportFormDataValeus(formData));
    }, _this.handleSubmit = function (event) {
      var formData = event.formData;
      var onSubmit = _this.props.onSubmit;


      onSubmit && onSubmit(exportFormDataValeus(formData));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FormDinamicoReactRender.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var form = nextProps.form,
        formData = nextProps.formData;


    if (compare(form, prevState.form) && compare(formData, prevState.formData)) {
      return null;
    }

    var localFormData = prevState.localFormData || {};

    return {
      localFormData: _extends({}, localFormData, formDefaultValues(form), formDataValues(formData))
    };
  };

  FormDinamicoReactRender.prototype.componentDidMount = function componentDidMount() {
    var fields = Object.keys(formToJSONSchema(this.props.form).properties);
    var emptyFormData = {};
    var localFormData = this.state.localFormData;

    //create object with right type for properties
    //fields.forEach(item => (emptyFormData[item] = ""));

    !Object.keys(localFormData).length && this.setState({
      localFormData: emptyFormData
    });
  };

  FormDinamicoReactRender.prototype.render = function render() {
    var _props = this.props,
        onChange = _props.onChange,
        onSubmit = _props.onSubmit,
        form = _props.form,
        formData = _props.formData,
        children = _props.children,
        environment = _props.environment,
        customWidgets = _props.customWidgets,
        rest = _objectWithoutProperties(_props, ["onChange", "onSubmit", "form", "formData", "children", "environment", "customWidgets"]);

    var localFormData = this.state.localFormData;


    var formProps = _extends({}, rest, {
      className: "container-fluid",
      schema: formToJSONSchema(form),
      uiSchema: formToUISchema(form, environment),
      formData: localFormData,
      FieldTemplate: CustomFieldTemplate,
      ObjectFieldTemplate: CustomObjectFieldTemplate, //
      fields: {
        ArrayField: CustomArrayField,
        ObjectField: CustomObjectField
      },
      onChange: this.handleChange,
      onSubmit: this.handleSubmit
    });

    var formWidgets = _extends({
      TextareaWidget: TextareaWidget,
      number: TextFieldWidget,
      TextWidget: TextFieldWidget,
      dateWidget: ReactDatePicker,
      titleWidget: TitleWidget,
      radio: RadioGroupWidget,
      checkboxes: CheckboxesGroupWidget,
      "file-multiple": MultipleUploadWidget,
      select: SelectWidget,
      richTextWidget: RichTextField,
      link: LinkWidget,
      location: LocationWidget,
      "table-editable": TableEditableWidget,
      mask: MaskWidget,
      paragraph: ParagraphWidget,
      "input-cpf": CpfWidget,
      "input-cnpj": CnpjWidget,
      "input-decimal": TextFieldWidget
    }, customWidgets);

    var validate = function validate(formData, errors) {
      var schema = formProps.schema;

      return defaultValidation(schema, formData, errors);
    };

    return React.createElement(
      Form,
      _extends({}, formProps, {
        widgets: formWidgets,
        noHtml5Validate: true,
        showErrorList: false,
        validate: validate,
        transformErrors: transformErrors
      }),
      children
    );
  };

  return FormDinamicoReactRender;
}(PureComponent);

FormDinamicoReactRender.propTypes = process.env.NODE_ENV !== "production" ? {
  form: PropTypes.shape({
    elements: PropTypes.array
  }).isRequired,
  formData: PropTypes.any,
  customWidgets: PropTypes.object,
  /* event handlers */
  onChange: PropTypes.func,
  onError: PropTypes.func,
  onSubmit: PropTypes.func,
  environment: PropTypes.shape({
    upload: PropTypes.shape({
      url: PropTypes.string.isRequired,
      config: PropTypes.object.isRequired
    }),
    customProps: PropTypes.object,
    headers: PropTypes.object,
    disableOnLoadIntegration: PropTypes.boolean
  })
} : {};


export default FormDinamicoReactRender;